import styled from 'styled-components';
import { COLORS, mediaQueries } from '../../../../utils/styles';

export const Disclaimer = styled.p`
  font-family: 'SanFrancisco';
  font-size: 11px;
  color: ${COLORS.naturalGray};
`;

export const FooterLink = styled.a`
  display: inline-block;
  padding: 0 15px;
  font-family: 'RobotoThin';
  font-size: 13px;
  color: #fff;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const Logo = styled.img`
  margin-top: 60px;
  max-width: 237px;
  width: 100%;
  ${mediaQueries.xs(`
    margin-top: 20px;
  `)};
`;

export const StyledHeader = styled.h2`
  margin-top: 10px;
  margin-bottom: 24px;
  font-family: 'RobotoThin';
  font-size: 19px;
  line-height: 1.47;
  color: #fff;
  letter-spacing: -0.2px;
`;

export const IconContainer = styled.div`
  margin: 28px 0 20px;
  ${mediaQueries.xs(`
    margin-top: 15px;
  `)};
`;

export const Icon = styled.img`
  height: 52px;
  margin: 0 3.2px;
`;

export const CenteredRow = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/views/sports-connect/layouts/AuthFlow/styled-components.js